// 钱包余额（新旧）与账户余额、公用下载/空态等 - 简体中文
export default {
  common: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
    download: "下载",
    downloadFilename: "数据明细",
    loading: "拼命加载中",
    empty: "暂无数据",
    copySuccess: "复制成功",
  },
  detail: {
    dialogTitle: "余额明细",
    top: {
      address: "地址：",
      addressBalanceUSDT: "地址总余额(USDT)：",
    },
    columns: {
      currency: "币种",
      quantity: "数量",
      balanceUSDT: "余额(USDT)",
      updateTime: "更新时间",
    },
  },
  newWallet: {
    columns: {
      address: "地址",
      balance: "余额",
      actions: "操作",
      viewDetails: "查看详情",
    },
  },
  wallet: {
    columns: {
      currency: "币种",
      balance: "余额",
    },
  },
  account: {
    columns: {
      type: "账户类型",
      balanceUSDT: "余额（USDT）",
    },
  },
};
